export default {
	invalidProps: '最小時間不能大於最大時間',
	invalidTime: '無效的時間格式',
	tooEarly: '所選時間不能小於最大時間',
	tooLate: '所選時間不能大於最大時間'
};
